import { useState, useContext, useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import DriverInfoDisplay from '../../../components/DriverInfoDisplay';
import AutoNavigate from '../../../components/AutoNavigate';
import { AppStateContext } from '../../../context/AppStateContextProvider';

export default function RideInRidePage() {
    const { userCurrentRide } = useContext(AppStateContext);

    const [localUserCurrentRide, setLocalUserCurrentRide] = useState(null);

    useEffect(() => {
        if (!userCurrentRide) {
            return;
        }

        setLocalUserCurrentRide(userCurrentRide);
    }, [userCurrentRide]);

    const rideStops = localUserCurrentRide?.stops || [];

    const isDriverHeadingToPickup =
        localUserCurrentRide?.pickupLocation != null &&
        localUserCurrentRide.pickupLocation.latitude === null;

    const getReadableTime = (timeValue) => {
        if (!timeValue) {
            return 'Not resumed yet';
        }

        const time = new Date(timeValue);
        if (Number.isNaN(time.getTime())) {
            return 'Invalid time';
        }

        return time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
    };

    return (
        <Box
            sx={{
                width: '100vw',
                height: '100dvh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
            }}
        >
            <AutoNavigate />
            <Box
                sx={{
                    backgroundImage: `url('/green-background.png')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    width: '100vw',
                    height: '50dvh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                {!isDriverHeadingToPickup && (
                    <img src="/in-ride-gif.gif" style={{ width: '173px', height: '75px' }} />
                )}
                <Typography
                    variant="h3"
                    sx={{
                        mt: 2,
                        fontSize: 28,
                        fontWeight: '600',
                        color: 'white',
                        mb: 2,
                    }}
                >
                    {isDriverHeadingToPickup ? 'Driver On The Way' : 'In Ride'}
                </Typography>
            </Box>

            <Box
                sx={{
                    width: '100vw',
                    height: '50dvh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgb(242,242,242)',
                }}
            >
                <DriverInfoDisplay
                    driver={localUserCurrentRide?.driver}
                    displayCallButton={false}
                />
                <Box sx={{ mt: 2, width: '88%', backgroundColor: 'white', borderRadius: 2, p: 2 }}>
                    <Typography sx={{ fontWeight: 600, mb: 1 }}>
                        Ride Stops: {rideStops.length}
                    </Typography>
                    {rideStops.length === 0 ? (
                        <Typography variant="body2">No stops added yet.</Typography>
                    ) : (
                        rideStops.map((stop, index) => (
                            <Typography
                                key={`${stop.stopTime}-${index}`}
                                variant="body2"
                                sx={{ mb: 0.5 }}
                            >
                                Stop {index + 1}: {getReadableTime(stop.stopTime)} - Resume:{' '}
                                {getReadableTime(stop.resumeTime)}
                            </Typography>
                        ))
                    )}
                </Box>
            </Box>
        </Box>
    );
}
